import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    status: 0,
    error: null,
    headerText: null,
    successText: null
  },
  mutations: {
    SWITCH_STATUS: (state, payload) => {
      state.status = payload
    },
    SET_ERROR_MSG: (state, payload) => {
      state.error = payload
    },
    SET_HEADER_TEXT: (state, payload) => {
      state.headerText = payload
    },
    SET_SUCCESS_TEXT: (state, payload) => {
      state.successText = payload
    }
  },
  actions: {
    setHeaderText ({ commit }, payload) {
      commit('SET_HEADER_TEXT', payload)
    },
    setSuccessText ({ commit }, payload) {
      commit('SET_SUCCESS_TEXT', payload)
    },
    switchStatus ({ commit }, payload) {
      commit('SWITCH_STATUS', payload)
    },
    setErrorMsg ({ commit, getters }) {
      switch (getters.currentStatus) {
        case 2: {
          commit('SET_ERROR_MSG', 'Ошибка авторизации.')
          break
        }
        case 3: {
          commit('SET_ERROR_MSG', 'Ошибка параметров.')
          break
        }
        case 4: {
          commit('SET_ERROR_MSG', 'Некорректный ИИН.')
          break
        }
        case 5: {
          commit('SET_ERROR_MSG', 'Некорректная сумма.')
          break
        }
        case 6: {
          commit('SET_ERROR_MSG', 'Некорректный номер телефона.')
          break
        }
        default: {
          commit('SET_ERROR_MSG', 'При отправке заявки произошла ошибка. Попробуйте еще раз.')
          break
        }
      }
    }
  },
  getters: {
    currentStatus: state => state.status,
    currentError: state => state.error,
    getHeaderText: state => state.headerText,
    getSuccessText: state => state.successText
  }
})

export default store
